import Service, { inject as service } from '@ember/service';

export default class CompanyTeamCommands extends Service {
  @service api;

  /**
   * @param companyTeamId
   * @param costCodeId
   * @returns {*}
   */
  addCostCode(companyTeamId, costCodeId) {
    return this.api.post(`company-teams/${companyTeamId}/addCostCode/${costCodeId}`);
  }

  /**
   * @param companyTeamId
   * @param storyCodeId
   * @returns {*}
   */
  addStoryCode(companyTeamId, storyCodeId) {
    return this.api.post(`company-teams/${companyTeamId}/addStoryCode/${storyCodeId}`);
  }

  /**
   * @param companyId
   * @param costCodeId
   * @return {*}
   */
  addCostCodeToAllTeams(companyId, costCodeId) {
    return this.api.post(`companies/${companyId}/addCostCodeToAllTeams/${costCodeId}`);
  }

  /**
   * @param companyId
   * @param storyCodeId
   * @return {*}
   */
  addStoryCodeToAllTeams(companyId, storyCodeId) {
    return this.api.post(`companies/${companyId}/addStoryCodeToAllTeams/${storyCodeId}`);
  }

  /**
   *
   * @param companyTeamId
   * @returns {*}
   */
  destroyCompanyTeam(companyTeamId) {
    return this.api.delete(`company-teams/${companyTeamId}`);
  }

  /**
   *
   * @param companyId
   * @returns {*}
   */
  loadCompanyTeams(companyId, includes = null) {
    const options = {};

    if (includes) {
      options.params = {
        include: includes.join(','),
      }
    }

    return this.api.request(`companies/${companyId}/company-teams`, options);
  }

  /**
   *
   * @param companyTeamId
   * @param costCodeId
   * @returns {*}
   */
  removeCostCode(companyTeamId, costCodeId) {
    return this.api.delete(`company-teams/${companyTeamId}/removeCostCode/${costCodeId}`);
  }

  /**
   *
   * @param companyId
   * @param name
   * @param description
   * @param colorHex
   * @returns {*}
   */
  storeCompanyTeam({
    companyId,
    name,
    description,
    colorHex,
  } = {}) {
    return this.api.post(`companies/${companyId}/company-teams`, {
      jsonData: {
        name,
        description,
        color_hex: colorHex,
      }
    });
  }

  /**
   *
   * @param companyTeamId
   * @param name
   * @param description
   * @param colorHex
   * @returns {*}
   */
  updateCompanyTeam({
    companyTeamId,
    name,
    description,
    colorHex,
  } = {}) {
    return this.api.put(`company-teams/${companyTeamId}`, {
      jsonData: {
        name,
        description,
        color_hex: colorHex,
      }
    });
  }
}
